import React, { Component } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

class SummaryReportGraph extends Component {
  constructor(props) {
    super(props);
    this.chartRef = React.createRef();
    this.root = null;
  }

  componentDidMount() {
    this.createChart();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.dataArray !== this.props.dataArray) {
      this.updateChart();
    }
  }

  componentWillUnmount() {
    if (this.root) {
      this.root.dispose();
    }
  }

  createChart() {
    // Dispose existing chart if any
    if (this.root) {
      this.root.dispose();
    }

    // Create root
    this.root = am5.Root.new(this.chartRef.current);

    // Apply themes
    this.root.setThemes([am5themes_Animated.new(this.root)]);

    // Remove amCharts logo
    if (this.root._logo) this.root._logo.dispose();

    // Set font size
    this.root.fontSize = 10;

    // Create pie chart
    this.chart = this.root.container.children.push(
      am5percent.PieChart.new(this.root, {
        endAngle: 270
      })
    );

    // Create series
    this.series = this.chart.series.push(
      am5percent.PieSeries.new(this.root, {
        valueField: "value",
        categoryField: "category",
        endAngle: 270
      })
    );

    this.series.labels.template.setAll({
      fontSize: 10
    });

    this.series.ticks.template.setAll({
      strokeWidth: 1
    });

    this.series.states.create("hidden", {
      endAngle: -90
    });

    // Initial load
    this.setSeriesData();
  }

  updateChart() {
    this.setSeriesData();
  }

  setSeriesData() {
    const { dataArray } = this.props;

    let processedData = [];
    let sum = 0;

    if (dataArray && dataArray.length > 0) {
      dataArray.forEach(item => {
        const val = parseInt(item.value, 10);
        sum += val;
      });

      dataArray.forEach(item => {
        const val = parseInt(item.value, 10);
        processedData.push({
          category: item.label,
          value: sum === 0 ? 1 : val
        });
      });

      if (sum === 0) {
        processedData = [{ category: "No Data", value: 1 }];
      }

    } else {
      processedData = [{ category: "No Data", value: 1 }];
    }

    this.series.data.setAll(processedData);
    this.series.labels.template.adapters.add("fill", (fill, target) => {
      const dataItem = target.dataItem;
      if (dataItem && dataItem.dataContext && dataItem.dataContext.value === 0) {
        return am5.color(0xcccccc);
      }
      return fill; 
    });
    
    this.series.labels.template.setAll({
      fontSize: 10,
      text: "{category} ({value})"
    });

    this.series.ticks.template.adapters.add("stroke", (stroke, target) => {
      const dataItem = target.dataItem;
      if (dataItem && dataItem.get("value") === 0) {
        return am5.color(0xcccccc); 
      }
      return stroke; 
    });

    this.series.ticks.template.setAll({
      strokeWidth: 2 
    });

    this.series.appear(1000, 100);
  }



  render() {
    return (
      <div
        ref={this.chartRef}
        style={{ width: "100%", height: '360px', margin: 'auto' }}
      />
    );
  }
}

function areEqual(prevProps, nextProps) {
  // Only re-render if dataArray reference or content changes
  if (prevProps.dataArray === nextProps.dataArray) return true;
  if (!prevProps.dataArray || !nextProps.dataArray) return false;
  if (prevProps.dataArray.length !== nextProps.dataArray.length) return false;
  for (let i = 0; i < prevProps.dataArray.length; i++) {
    if (
      prevProps.dataArray[i].label !== nextProps.dataArray[i].label ||
      prevProps.dataArray[i].value !== nextProps.dataArray[i].value
    ) {
      return false;
    }
  }
  return true;
}

export default React.memo(SummaryReportGraph, areEqual);
//  export default SummaryReportGraph;











// export default class SummaryReportGraph extends Component {
//   constructor(props){
//     super(props);
//   }
// 	state = { chart: null }

// 	componentDidMount = () => {
// 		this.load();
// 	}
//   componentDidUpdate = (prevProps) => {
//     if(this.props.dataArray !== prevProps.dataArray){
//       if(this.state.chart) this.state.chart.destroy();
//       this.load();
//     }
//   }

// 	load = () => {
//     let {dataArray, chartId} = this.props;
//     let series = [];
//     let labels = [];
//     if(dataArray && dataArray.length > 0){
//       let sum = 0;
//       for(let i=0; i<dataArray.length; i++){
//         series.push(parseInt(dataArray[i]['value'], 10));
//         labels.push(dataArray[i]['label']);
//         sum += dataArray[i]['value'];
//       }
//       labels = labels.map((item, index) => {
//         return sum==0? (item+"(0%)"): (item + " (" + Math.round((series[index]/sum)*100) + "%)")
//       }
//       )
//       if(sum==0){
//         series.push(1);
//         labels.push('No Data');
//       }
//     }else{
//       series = [1];
//       labels = ['No Data'];
//     }
// 		let options = {
//             series, 
//             chart: {
//               height: 300,
//               type: 'pie',
//               zoom: {
//                 enabled: true
//               },
//               toolbar: {
//                 show: false
//               }
//             },
//             labels, 
//             // colors: ['#231e0b', '#86df6a', '#9ac192', '#65297a', '#132f5f', '#70d9ec','#6337e6','#fb2d6d','#559f07', "#64a680","#5ea894"],
//             dataLabels: {
//               enabled: true
//             },
//             tooltip: {
//               enabled: true,
//             },
//             responsive: [{
//               breakpoint: 480,
//               options: {
//                 chart: {
//                   width: 300
//                 },
//                 legend: {
//                   position: 'bottom'
//                 }
//               }
//             }]
//           };
          
		  
		  
// 		var chart = new ApexCharts(document.querySelector(`#${chartId}`), options);
// 		chart.render();
// 		this.setState({chart: chart})
// 	}
// 	render() {
// 		return (
// 			<div id={this.props.chartId}></div>
// 		);
// 	}
// }